<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="全部" name="a" itemtype="" style="width: 100px">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge class="item">
              <span style="width: 100px">全部</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="待支付" name="b" itemtype="0">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status0" class="item">
              <span>待支付</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="待发货" name="c">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status1" class="item">
              <span>待发货</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已发货" name="f">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status4" class="item">
              <span>已发货</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已完成" name="g">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status8" class="item">
              <span>已完成</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="退款中" name="d">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status2" class="item">
              <span>退款中</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已退款" name="e">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status3" class="item">
              <span>已退款</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>

    <!-- 搜索部分 -->
    <div class="table-container">
      <vab-query-form style="margin: 0">
        <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent>
          <el-form-item label="">
            <el-input v-model.trim="queryForm.user_code" placeholder="用户编号" clearable style="width: 150px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.batch_code" placeholder="批次编号" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.code" placeholder="订单编号" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.express_code" placeholder="运单编号" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="queryForm.is_supplement" clearable placeholder="商品类型" @keyup.enter.native="handleQuery"
              style="width: 150px;">
              <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.user_name" placeholder="收货人" clearable style="width: 150px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.goods_name" placeholder="商品名" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.barcode" placeholder="商品条形码" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.record" placeholder="商品备案码" clearable style="width: 200px" />
          </el-form-item>
          <!-- 下单时间 -->
          <el-form-item label="">
            <el-date-picker v-model="time" type="datetimerange" start-placeholder="下单时间起" range-separator="-"
              value-format="yyyy-MM-dd HH:mm:ss" end-placeholder="下单时间止" style="width: 360px"
              :default-time="['00:00:00', '23:59:59']" @change="getListData" />
          </el-form-item>
          <!-- 退款时间 -->
          <el-form-item label="">
            <el-date-picker v-model="refundTime" type="datetimerange" start-placeholder="退款时间起" range-separator="-"
              value-format="yyyy-MM-dd HH:mm:ss" end-placeholder="退款时间止" style="width: 360px"
              :default-time="['00:00:00', '23:59:59']" @change="getRefundTime" />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-download" type="primary" @click="export_excel">
              导出
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-delete" type="danger" @click="handleDelete">
              批量删除
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="batchOrderPull(4)">
              顺丰批量拉单
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="batchOrderPull(7)">
              中通批量拉单
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button :loading="SFHdoPreviewLoading" type="primary" @click="get_size(0, 'SFH')">
              打印面单
            </el-button>
          </el-form-item>
          <el-form-item v-if="queryForm.status == 1">
            <el-button type="success" @click="batchPurchased(4)">
              批量已采购
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form>

      <el-table ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
        :height="height" style="width: 100%" border @selection-change="setSelectRows" @sort-change="tableSortChange"
        stripe>
        <el-table-column show-overflow-tooltip type="selection" width="55" align="center"></el-table-column>

        <!-- 用户ID -->
        <el-table-column prop="user_code" label="用户编号" align="center" width="90">
          <template #default="{ row }">
            <div>{{ row.user_code }}</div>
            <el-tag v-if="row.is_purchase == 1" size="mini" type="success">已采购</el-tag>
          </template>
        </el-table-column>

        <!-- 商品规格（已压缩：默认显示 2 个，可展开） -->
        <el-table-column align="left" width="400" label="商品信息">
          <template #default="{ row }">
            <div class="sku-list">
              <div class="sku_item" v-for="(item, index) in getDisplaySpecs(row)" :key="index">
                <el-image class="sku-image" :src="torul(item.pic ? item.pic : row.pic)"
                  :preview-src-list="[torul(item.pic ? item.pic : row.pic)]" fit="cover">
                  <div slot="error" class="sku-image-empty">暂无</div>
                </el-image>


                <div class="sku-info" @click="goGoodsList(item)" cursor: pointer>
                  <div class="sku-name link" :title="buildSkuTitle(item)">{{ item.goods_name }}</div>
                  <div class="sku-meta">
                    <span v-if="item.sku" class="sku-spec" :title="item.sku">规格：{{ item.sku }}</span>
                    <span class="sku-price">¥{{ item.price }}</span>
                    <span class="sku-num">数量：{{ item.num }}</span>
                    <span :title="item.sku">税金：{{ item.tax_formula }} = {{ item.tax_rate }}</span>
                    <span v-if="item.status == 2 && item.refund_num" class="sku-refund">已退款*{{ item.refund_num }}</span>
                  </div>
                </div>


              </div>
              <!-- 展开 / 收起 -->
              <div v-if="(row.goods_order_spec || []).length > 2" class="sku-toggle" @click="toggleExpand(row.id)">
                <i :class="expandedOrders[row.id] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                {{ expandedOrders[row.id] ? '收起' : `展开其余 ${row.goods_order_spec.length - 2} 个商品` }}
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column label="状态" align="center" width="80">
          <template #default="{ row }">
            <el-tag v-if="row.status == 0" size="mini" type="warning">待支付</el-tag>
            <el-tag v-else-if="row.status == 1" size="mini" type="warning">待发货</el-tag>
            <el-tag v-else-if="row.status == 4" size="mini" type="success">已发货</el-tag>
            <el-tag v-else-if="row.status == 2" size="mini" type="info">退款中</el-tag>
            <el-tag v-else-if="row.status == 3" size="mini" type="danger">已退款</el-tag>
            <el-tag v-else-if="row.status == 8" size="mini" type="success">已完成</el-tag>
            <span v-else class="muted-text">-</span>
          </template>
        </el-table-column>

        <!-- 订单信息 -->
        <el-table-column align="left" label="订单信息">
          <template #default="{ row }">
            <div class="order-info">
              <div class="order-line">
                <span class="info-label">订单编号</span>
                <span class="info-value" :title="row.code">{{ row.code || '-' }}</span>
              </div>
              <div class="order-line">
                <span class="info-label">支付单号</span>
                <span class="info-value" :title="row.pay_code">{{ row.pay_code || '-' }}</span>
              </div>
              <div class="order-line">
                <span class="info-label">下单时间</span>
                <span class="info-value" :title="row.add_time">{{ row.add_time || '-' }}</span>
              </div>
              <div v-if="row.status == 1 && row.is_supplement == 0" class="express_code_css full">
                <span class="info-label">运单编号</span>
                <el-input v-model="row.express_code" size="mini" class="express-input" placeholder="输入运单号" />
                <el-button size="mini" type="primary" plain @click="yundanHao_change(row)">保存</el-button>
              </div>
              <div v-else-if="row.status == 4 && row.is_supplement == 0" class="order-line full">
                <span class="info-label">运单编号</span>
                <span class="info-value">{{ row.express_code || '-' }}</span>
              </div>
              <div v-if="row.batch_code" class="order-line">
                <span class="info-label">拉单批次编号</span>
                <span class="info-value" :title="row.batch_code">{{ row.batch_code || '-' }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 收货信息 -->
        <el-table-column label="收货信息">
          <template #default="{ row }">
            <div class="order-line">
              <span class="info-label">收货人</span>
              <span class="info-value" :title="row.name">{{ row.name || '-' }}</span>
            </div>
            <div class="order-line">
              <span class="info-label">手机号</span>
              <span class="info-value" :title="row.name">{{ row.phone || '-' }}</span>
            </div>
            <div class="order-line">
              <span class="info-label">身份证</span>
              <span class="info-value" :title="row.idcode">{{ row.idcode || '-' }}</span>
            </div>
            <div v-if="row.is_supplement == 0" class="order-line address-line full">
              <span class="info-label">收货地址</span>
              <el-tooltip :content="row.province + row.city + row.area + row.address" placement="top">
                <span class="info-value">{{ row.province }}{{ row.city }}{{ row.area }}{{ row.address }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <!-- 订单金额 -->
        <el-table-column show-overflow-tooltip width="220" prop="price" label="金额明细">
          <template #default="{ row }">
            <div class="amount-line"><span>订单总额</span><strong>¥{{ row.total_price }}</strong></div>
            <div v-if="row.price > 0" class="amount-line"><span>商品总价</span><b>¥{{ row.goods_total_price }}</b></div>
            <!-- <div v-if="row.exceed_tax > 0" class="amount-line"><span>超出税金</span><b>¥{{ row.exceed_tax }}</b></div> -->
            <div v-if="row.weight_postage_price > 0" class="amount-line"><span>运费</span><b>¥{{ row.weight_postage_price
            }}</b></div>

            <div v-if="Number(row.tax) > 0" class="amount-line">
              <span>税金</span>
              <b>
                ¥<span class="strike">{{ row.tax }}</span>
                ¥{{ Number(row.tax) > 50 ? row.exceed_tax : 0 }}
              </b>
            </div>
            <div v-if="row.coupon_money > 0" class="amount-line"><span>优惠券</span><b>-¥{{ row.coupon_money }}</b></div>
            <div class="amount-total" style="font-size: 15px; font-weight: bold; "><span>实付款</span>¥{{ row.price }}
            </div>
            <div v-if="row.status == 3 && row.pay_log && row.pay_log.cash_price > 0" class="amount-line refund">
              <span>现金退款</span><b>{{ row.pay_log.cash_price }}</b>
            </div>
            <div v-if="row.status == 3 && row.pay_log && row.pay_log.refund_balance > 0" class="amount-line refund">
              <span>余额退款</span><b>{{ row.pay_log.refund_balance }}</b>
            </div>
            <div v-if="(row.status == 3 || row.status == 2) && row.order_apply_refund" class="amount-line refund">
              <span>退款原因</span><b class="refund-reason" :title="row.order_apply_refund.apply_reason">{{
                row.order_apply_refund.apply_reason }}</b>
            </div>
            <div v-if="row.status == 3 && row.order_apply_refund" class="amount-line refund">
              <span>退款时间</span><b>{{ row.order_apply_refund.add_time }}</b>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="110" fixed="right">
          <template #default="{ row }">
            <div class="op-btns">
              <el-button v-if="row.is_supplement == 0 && row.status == 1" type="text" size="mini"
                @click="handleEdit(row)">修改地址</el-button>
              <el-button v-if="row.status == 1" type="text" size="mini" @click="fahuo(row)">发货</el-button>
              <el-button v-if="row.status == 0" style="color: red;" type="text" size="mini"
                @click="colos_order(row)">关闭订单</el-button>
              <el-button v-if="row.status == 0" style="color: red;" type="text" size="mini"
                @click="handleDelete(row)">删除</el-button>
              <el-button v-if="row.status == 2" style="color: orange;" type="text" size="mini"
                @click="refund(row)">退款审核</el-button>
              <el-button v-if="row.status == 1" style="color: orange;" type="text" size="mini"
                @click="voluntaryRefund(row)">申请退款</el-button>
              <el-button v-if="row.status == 4" type="text" size="mini" @click="signCompleted(row)">签收完成</el-button>
              <el-button type="text" size="mini" @click="refundDetail(row)">退款明细</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
        :page-sizes="[20, 40, 60, 100]" :page-size="queryForm.limit" :total="total"
        @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>

      <commodity-list ref="edit" @fetch-data="getnewlist"></commodity-list>
      <tui-kuan ref="tuikuan" @change="getnewlist"></tui-kuan>
      ‌<VoluntaryRefund ref="voluntaryRefund" @change="getnewlist"></VoluntaryRefund>
      ‌<modifyAddress ref="modifyAddress" @change="getnewlist"></modifyAddress>
      <refund-detail ref="refundDetail" />

      <el-dialog title="面单尺寸" :visible.sync="mianDan_chiCun_show">
        <el-form>
          <el-form-item label="面单尺寸" :label-width="formLabelWidth">
            <el-select v-model="mianDan_chiCun_num" placeholder="请选择面单尺寸">
              <el-option label="100*150" :value="1"></el-option>
              <el-option label="100*180" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="mianDan_chiCun_show = false">取 消</el-button>
          <el-button type="primary" @click="shure_size">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  goodsOrderDel,
  goodsOrderList,
  orderRefundRefund,
  deliver_goods,
  GoodsOrder_excel_out,
  goodsOrderStatus,
  Index_country_list,
  GoodsOrder_cancelOrder,
  goods_order_api,
  print_detail,
  express_update,
  confirm_receipt
} from '@/api/xgcApi'
import {
  baseURL_print,
  getUploadUrl
} from '@/config'
import commodityList from '../components/commodityList.vue'
import modifyAddress from '../components/modifyAddress.vue'
import tuiKuan from '../components/tuikuanGoods.vue'
import VoluntaryRefund from '../components/‌goodsVoluntaryRefund.vue'
import RefundDetail from '../components/refundDetail.vue'

export default {
  name: 'manageCommodityList',
  components: {
    commodityList,
    tuiKuan,
    VoluntaryRefund,
    modifyAddress,
    RefundDetail
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      formLabelWidth: '100px',
      height: '72vh',
      xin_list: [],
      list: [],
      imageList: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      background: true,
      selectRows: '',
      elementLoadingText: '正在加载...',
      // 控制每个订单商品展开状态
      expandedOrders: {},
      queryForm: {
        page: 1,
        limit: 20,
        status: '',
        gtype: '2',
        kor_type: 0,
        start_time: '',
        end_time: '',
        user_code: '',
        is_supplement: '0',
        record: '',
        barcode: '',
        goods_name: '',
        start_refund_time: '',
        end_refund_time: '',
        batch_code: ''
      },
      value1: '',
      value: '',
      activeName: 'a',
      remindCount: {},
      isShowCode: false,
      options1: [{
        value: '0',
        label: '普通商品',
      },
      {
        value: '1',
        label: '补价商品 ',
      },
      ],
      yt_type: null,
      name_type: null,
      mianDan_chiCun_show: false,
      mianDan_chiCun_num: 1,
      SFHdoPreviewLoading: false,
      time: [],
      refundTime: [],
      socket: null,
      doPrintLoading: false,
      doPreviewLoading: false,
      SFdoPreviewLoading: false,
      SFHdoPreviewLoading: false,
      printTaskId: 0,
      printers: null,
      defaultPrinter: null,
      waybillNO: '0000000000000',
      waybillTemplateURL: baseURL_print + 'admin/index/print',
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.getXian()
    this.doConnect()
  },
  methods: {
    goGoodsList(item) {
      this.$router.push({
        path: '/goodManage/regulate/manageGoods/index',   // 改成实际商品列表路由
        query: {
          goods_name: item.goods_name || '',
        },
      })
    },
    /* ============ 商品折叠相关 ============ */
    getDisplaySpecs(row) {
      const specs = row.goods_order_spec || []
      if (this.expandedOrders[row.id]) return specs
      return specs.slice(0, 2)
    },
    toggleExpand(id) {
      this.$set(this.expandedOrders, id, !this.expandedOrders[id])
    },
    buildSkuTitle(item) {
      const parts = [item.goods_name]
      if (item.sku) parts.push(`规格：${item.sku}`)
      if (item.price) parts.push(`单价：¥${item.price}`)
      if (item.num) parts.push(`数量：${item.num}`)
      if (item.barcode) parts.push(`条码：${item.barcode}`)
      if (item.record) parts.push(`备案：${item.record}`)
      return parts.join('\n')
    },

    /* ============ 原有逻辑（保持不变） ============ */
    yundanHao_change(row) {
      var data = {
        id: row.id,
        express_code: row.express_code,
      }
      express_update(data).then((res) => {
        this.$baseMessage('修改成功', 'success')
        this.handleQuery()
      })
    },
    getListData() {
      if (!this.time || this.time.length == 0) {
        this.queryForm.start_time = '';
        this.queryForm.end_time = '';
      } else {
        this.queryForm.start_time = this.time[0];
        this.queryForm.end_time = this.time[1];
      }
       this.handleQuery()
    },
    // 获取退款时间
    getRefundTime() {
      if (!this.refundTime || this.refundTime.length == 0) {
        this.queryForm.start_refund_time = '';
        this.queryForm.end_refund_time = '';
      } else {
        this.queryForm.start_refund_time = this.refundTime[0];
        this.queryForm.end_refund_time = this.refundTime[1];
      }
       this.handleQuery()
    },

    refundDetail(row) {
      this.$refs.refundDetail.open(row)
    },
    get_size(type, name) {
      this.yt_type = type
      this.name_type = name
      this.mianDan_chiCun_show = true
    },
    shure_size() {
      if (this.name_type == 'SFH') {
        if (this.yt_type == 0) {
          this.doPrint('SFH')
        } else {
          this.doPreview('SFH')
        }
      }
      this.mianDan_chiCun_show = false
    },
    doPreview(type) {
      if (this.selectRows.length > 0) {
        if (type == 'YT') {
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 1) {
              ids.push(item.id)
            }
          })
          this.$baseConfirm('你确定打印预览选中项吗', null, async () => {
            var data = {
              id: ids,
              type: this.mianDan_chiCun_num,
            }
            Order_printCheck(data).then((res) => {
              var printData = this.getPrintData()
              printData.task.preview = true
              this.doPreviewLoading = true
              this.socket.send(JSON.stringify(printData))
            })
          })
        }
        if (type == 'SFK') {
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 3) {
              ids.push(item.id)
            }
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            urls = 'https://cloudprint.cainiao.com/template/standard/877837'
          } else {
            urls =
              'https://cloudprint.cainiao.com/template/standard/771230/16'
          }
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code,
                      logisticsNo: item.express_code,
                      shortAddress: item.pulling.mark,
                      packageCenterName: item.packageCenterName,
                      consignee: item.name,
                      consigneeTel: item.phone,
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`,
                      consigner: from.username,
                      consignerTel: from.mobile,
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`,
                      goodsInfo: goodsInfo,
                      note: item.remark2,
                      logisticsMark: '',
                      twoDimensionCode: item.pulling.two_dimension_code,
                      now: item.add_time,
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            printData.task.preview = true
            this.SFKdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
        if (type == 'SFH') {
          var ids = []
          this.selectRows.forEach((item) => {
            ids.push(item.id)
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            urls = 'https://cloudprint.cainiao.com/template/standard/877264'
          } else {
            urls = 'https://cloudprint.cainiao.com/template/standard/765571'
          }
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code,
                      logisticsNo: item.express_code,
                      shortAddress: item.pulling.mark,
                      packageCenterName: item.packageCenterName,
                      consignee: item.name,
                      consigneeTel: item.phone,
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`,
                      consigner: from.username,
                      consignerTel: from.mobile,
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`,
                      goodsInfo: goodsInfo,
                      note: item.remark2,
                      logisticsMark: '',
                      twoDimensionCode: item.pulling.two_dimension_code,
                      now: item.add_time,
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            printData.task.preview = true
            this.SFHdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    handleEdit(row) {
      this.$refs['modifyAddress'].showEdit(row)
    },
    colos_order(row) {
      var data = {
        "id": row.id
      }
      this.$confirm('确认手动关闭此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then((success) => {
        GoodsOrder_cancelOrder(data).then(res => {
          this.$message({
            type: 'success',
            message: '关闭成功'
          })
          this.fetchData()
        }).catch(err => { })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作',
          })
        })
    },
    getXian() {
      Index_country_list({}).then(res => {
        this.xin_list = res.data
      })
    },
    torul(url) {
      var arr = url?.split(",") ?? [];
      return arr[0] || '';
    },
    export_excel() {
      if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id).join()
        var data = {
          id: ids
        }
        GoodsOrder_excel_out(data).then(res => {
          this.$message({
            type: 'success',
            message: '导出成功'
          })
          const fileUrl = getUploadUrl + res.data
          window.location.href = fileUrl
        })
      } else {
        GoodsOrder_excel_out(this.queryForm).then(res => {
          this.$message({
            type: 'success',
            message: '条件导出成功',
          })
          const fileUrl = getUploadUrl + res.data
          window.open(fileUrl)
        })
      }
    },
    fahuo(row) {
      this.$confirm('确认继续发货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then((success) => {
          var data = {
            "order_id": row.id,
            "status": 4
          }
          goodsOrderStatus(data).then((res) => {
            this.$message({
              type: 'success',
              message: '发货成功!',
            })
            this.getnewlist()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消发货',
          })
        })
    },
    signCompleted(row) {
      this.$confirm('确认签收完成?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then((success) => {
          var data = {
            id: row.id,
          }
          confirm_receipt(data).then((res) => {
            this.$message({
              type: 'success',
              message: '签收成功!',
            })
            this.getnewlist()
          })
        })
        .catch((err) => { })
    },
    handleClick(tab, event) {
      switch (tab.name) {
        case 'a':
          this.queryForm.status = ''
          break
        case 'b':
          this.queryForm.status = 0
          break
        case 'c':
          this.queryForm.status = 1
          break
        case 'd':
          this.queryForm.status = 2
          break
        case 'e':
          this.queryForm.status = 3
          break
        case 'f':
          this.queryForm.status = 4
          break
        case 'g':
          this.queryForm.status = 8
          break
      }
      this.queryForm.page = 1
      this.fetchData()
    },
    getnewlist() {
      this.fetchData()
    },
    tableSortChange() {
      const imageList = []
      this.$refs.tableSort.tableData.forEach((item, index) => {
        imageList.push(item.img)
      })
      this.imageList = imageList
    },
    setSelectRows(val) {
      this.selectRows = val
      this.chooseItem = val
    },
    handledetails(row) {
      this.$refs['edit'].showEdit(row)
    },
    voluntaryRefund(row) {
      var type = row.gtype == 1 ? 2 : 5
      this.$refs['voluntaryRefund'].open(row, type)
    },
    refund(row) {
      var type = row.gtype == 1 ? 2 : 5
      this.$refs['tuikuan'].open(row, type)
    },
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm('你确定要删除当前项吗', null, async () => {
          const {
            msg
          } = await goodsOrderDel({
            id: row.id,
          })
          this.$baseMessage(msg, 'success')
          this.fetchData()
        })
      } else {
        if (this.selectRows.length > 0) {
          const ids = this.selectRows.map((item) => item.id).join()
          this.$baseConfirm('你确定要删除选中项吗', null, async () => {
            const {
              msg
            } = await goodsOrderDel({
              id: ids,
            })
            this.$baseMessage(msg, 'success')
            this.fetchData()
          })
        } else {
          this.$baseMessage('未选中任何行', 'warning')
          return false
        }
      }
    },
    batchOrderPull(type) {
      if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id).join()
        this.$baseConfirm('确定进行拉单操作？', null, async () => {
          const {
            msg
          } = await goods_order_api({
            id: ids,
            type: type
          })
          this.$baseMessage(msg, 'success')
          this.fetchData()
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    batchPurchased(type) {
      if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id).join()
        this.$baseConfirm('确定商品已采购？', null, async () => {
          const {
            msg
          } = await goodsOrderStatus({
            order_id: ids,
            is_purchase: 1
          })
          this.$baseMessage(msg, 'success')
          this.fetchData()
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    doConnect() {
      var that = this
      this.socket = new WebSocket('ws://127.0.0.1:13528')
      var result = '打印成功'
      var tmptaskID = '0'
      that.socket.onopen = function (event) {
        that.socket.onmessage = function (event) {
          var data = JSON.parse(event.data)
          that.printers = data.printers
          that.defaultPrinter = data.defaultPrinter
          if (data.cmd == 'notifyPrintResult') {
            var result = '打印成功'
            if (data.taskID != tmptaskID) {
              for (var i = 0; i < data.printStatus.length; i++) {
                if (data.printStatus[i].status == 'failed') {
                  result = '打印失败'
                  that.$message({ type: 'error', message: '打印失败' })
                  break
                } else if (data.printStatus[i].status == 'canceled') {
                  that.$message({ type: 'error', message: '取消打印任务' })
                  result = '取消打印任务'
                  break
                }
              }
              tmptaskID = data.taskID
            }
            that.doPreviewLoading = false
            that.doPrintLoading = false
            that.SFdoPreviewLoading = false
            that.SFHdoPreviewLoading = false
          } else if (data.cmd == 'print') {
            that.doPreviewLoading = false
            that.doPrintLoading = false
            that.SFdoPreviewLoading = false
            that.SFHdoPreviewLoading = false
            if (data.previewURL) {
              window.open(data.previewURL)
            } else {
              var ids = []
              that.chooseItem.forEach((item, index) => {
                ids.push(item.id)
              })
              var date = {
                id: ids.join(','),
              }
              if (data.status != 'success') {
                that.$message({ type: 'error', message: data.msg })
              } else {
                Order_printStatus(date).then((res) => {
                  that.$message({ type: 'success', message: '打印成功' })
                })
              }
            }
          }
        }
        that.socket.onclose = function (event) {
          that.$message({ type: 'error', message: '打印机失去联系，请刷新网页重新连接' })
        }
      }
      that.socket.onerror = function (event) {
        that.$message({ type: 'error', message: '打印机出现问题,请联系客服' })
      }
    },
    doPrint(type) {
      if (this.selectRows.length > 0) {
        if (type == 'YT') {
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 1) {
              ids.push(item.id)
            }
          })
          this.$baseConfirm('你确定打印预览选中项吗', null, async () => {
            var data = {
              id: ids,
              type: this.mianDan_chiCun_num,
            }
            Order_printCheck(data).then((res) => {
              var printData = this.getPrintData()
              this.doPreviewLoading = true
              this.socket.send(JSON.stringify(printData))
            })
          })
        }
        if (type == 'SFK') {
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 3) {
              ids.push(item.id)
            }
          })
          var data = { id: ids }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            urls = 'https://cloudprint.cainiao.com/template/standard/877837'
          } else {
            urls = 'https://cloudprint.cainiao.com/template/standard/771230/16'
          }
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code,
                      logisticsNo: item.express_code,
                      shortAddress: item.pulling.mark,
                      packageCenterName: item.packageCenterName,
                      consignee: item.name,
                      consigneeTel: item.phone,
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`,
                      consigner: from.username,
                      consignerTel: from.mobile,
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`,
                      goodsInfo: goodsInfo,
                      note: item.remark2,
                      logisticsMark: '',
                      twoDimensionCode: item.pulling.two_dimension_code,
                      now: item.add_time,
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            this.SFKdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
        if (type == 'SFH') {
          var ids = []
          this.selectRows.forEach((item) => {
            ids.push(item.id)
          })
          var data = {
            goods_order_id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            urls = 'https://cloudprint.cainiao.com/template/standard/877264'
          } else {
            urls = 'https://cloudprint.cainiao.com/template/standard/765571'
          }
          print_detail(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              let result = ''
              if (item.goods_order_spec && item.goods_order_spec.length > 0) {
                const merged = item.goods_order_spec.reduce((acc, t) => {
                  const key = t.sku;
                  acc[key] = (acc[key] || 0) + t.num;
                  return acc;
                }, {});
                result = Object.entries(merged)
                  .map(([name, num]) => `${name} * ${num}`)
                  .join(" , ");
              }
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code,
                      logisticsNo: item.express_code,
                      shortAddress: item.pulling.mark,
                      packageCenterName: item.packageCenterName,
                      consignee: item.name,
                      consigneeTel: item.phone,
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`,
                      consigner: from.username,
                      consignerTel: from.mobile,
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`,
                      goodsInfo: result,
                      note: item.remark2,
                      logisticsMark: '',
                      twoDimensionCode: item.express_code,
                      now: item.add_time,
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            this.SFHdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    getPrintData() {
      var dataArr = []
      this.chooseItem.forEach((item, ind) => {
        if (item.pulling_type == 1) {
          dataArr.push({
            documentID: this.waybillNO,
            contents: [
              {
                templateURL: `${this.waybillTemplateURL}?id=${item.id}&type=${this.mianDan_chiCun_num}`,
                signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
              },
            ],
          })
        }
      })
      if (dataArr.length <= 0) {
        this.$message({ type: 'warning', message: '没有可打印的圆通面单' })
        return
      }
      this.printTaskId = parseInt(1000 * Math.random())
      var request = {
        cmd: 'print',
        requestID: '12345678901234567890',
        version: '1.0',
        task: {
          taskID: '' + this.printTaskId,
          preview: false,
          printer: this.defaultPrinter,
          notifyMode: 'allInOne',
          previewType: 'pdf',
          documents: dataArr,
        },
      }
      return request
    },
    SFgetPrintData(arrs) {
      var dataArr = []
      if (arrs.length <= 0) {
        this.$message({ type: 'warning', message: '没有可打印的顺丰面单' })
        return
      }
      this.printTaskId = parseInt(1000 * Math.random())
      var request = {
        cmd: 'print',
        requestID: '12345678901234567890',
        version: '1.0',
        task: {
          taskID: '' + this.printTaskId,
          preview: false,
          printer: this.defaultPrinter,
          notifyMode: 'allInOne',
          previewType: 'pdf',
          documents: arrs,
        },
      }
      return request
    },
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    handleQuery() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const {
        data
      } = await goodsOrderList(this.queryForm)
      this.list = data.list
      this.remindCount = data.statusCount
      this.total = data.count
      const imageList = []
      data.list.forEach((item, index) => {
        imageList.push(item.pic)
      })
      this.imageList = imageList
      setTimeout(() => {
        this.listLoading = false
      }, 500)
    },
  },
}
</script>

<style scoped>
.table-container {
  padding: 12px 14px 0;
  box-sizing: border-box;
  background: #fff;
}

::v-deep .el-tabs__header {
  margin: 0 0 0px !important;
}

::v-deep .el-tabs__item {
  min-width: 100px;
  text-align: center;
  padding: 0 22px;
  font-weight: 500;
}

::v-deep .el-tabs__item.is-active {
  color: #4569c8;
  font-weight: 600;
}

::v-deep .el-badge__content.is-fixed {
  top: 8px;
  right: 4px;
}

::v-deep .el-form--inline .el-form-item {
  margin-right: 10px;
  margin-bottom: 8px;
  vertical-align: top;
}

::v-deep .el-input__inner,
::v-deep .el-select .el-input__inner {
  border-radius: 4px;
}

::v-deep .el-button--mini {
  padding: 4px 8px;
}

/* ---------- 表格整体压缩 ---------- */
::v-deep .el-table {
  color: #455166;
  font-size: 12.5px;
  border-radius: 4px;
}

::v-deep .el-table th {
  background: #f5f7fb;
  color: #38445a;
  font-weight: 600;
  height: 38px;
  padding: 6px 0;
}

/* 关键：把单元格上下 padding 从 8px 压到 4px */
::v-deep .el-table td {
  padding: 4px 0;
}

::v-deep .el-table .cell {
  line-height: 1.4;
}

::v-deep .el-table__fixed-right::before,
::v-deep .el-table__fixed::before {
  background-color: #e8edf5;
}

/* ---------- 商品列表（压缩版） ---------- */
.sku-list {
  width: 100%;
}

.sku_item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
}

.sku_item:first-child {
  padding-top: 0;
}

.sku-image {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border: 1px solid #edf0f5;
  border-radius: 4px;
  background: #fff;
}

.sku-image-empty {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0a8b7;
  font-size: 10px;
  background: #f7f8fa;
}

.sku-info {
  min-width: 0;
  flex: 1;
  text-align: left;
}

.sku-name {
  color: #303b4f;
  font-weight: 500;
  font-size: 12.5px;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sku-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0 8px;
  margin-top: 1px;
  color: #69758a;
  font-size: 11.5px;
  line-height: 15px;
}

.sku-spec {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #8993a5;
}

.sku-num {
  color: #333;
  font-weight: 600;
}

.sku-price {
  color: #e35b5b;
}

.sku-refund {
  color: red;
}

.sku-toggle {
  margin-top: 2px;
  font-size: 12px;
  line-height: 16px;
  color: #4569c8;
  cursor: pointer;
  user-select: none;
}

.sku-toggle:hover {
  color: #6a87e0;
  text-decoration: underline;
}

/* ---------- 订单信息（两列网格，行数减半） ---------- */
.order-info {
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px 14px;
  text-align: left; */
}

.order-line {
  display: flex;
  align-items: center;
  min-width: 0;
  line-height: 18px;
}

.order-line.full,
.express_code_css {
  grid-column: 1 / -1;
}

.info-label {
  flex: 0 0 56px;
  color: #8993a5;
  font-size: 12px;
  white-space: nowrap;
}

.info-value {
  min-width: 0;
  flex: 1;
  color: #455166;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.address-line .info-value {
  display: block;
}

.express_code_css {
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 18px;
}

.express_code_css .info-label {
  flex: 0 0 56px;
}

.express-input {
  min-width: 80px;
  flex: 1;
}

.express_code_css ::v-deep .el-input__inner {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
}

/* ---------- 金额明细（无分隔线，紧凑） ---------- */
.amount-line,
.amount-total {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin: 0;
  line-height: 17px;
  font-size: 12px;
}

.amount-line span,
.amount-total span {
  color: #8993a5;
}

.amount-line b {
  color: #455166;
  font-weight: 400;
  text-align: right;
}

.amount-total {
  padding: 0;
  border-bottom: 0;
}

.amount-total strong {
  color: #e35b5b;
  font-size: 13px;
  white-space: nowrap;
}

.amount-line.refund span,
.amount-line.refund b {
  color: red;
}

.refund-reason {
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.muted-text {
  color: #a0a8b7;
}

/* ---------- 操作按钮（横向换行，行高 18px） ---------- */
.op-btns {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0 4px;
}

::v-deep .op-btns .el-button--text {
  margin: 0;
  padding: 1px 0;
  font-size: 12px;
  line-height: 18px;
}

@media screen and (max-width: 1366px) {
  .table-container {
    padding: 10px 8px 0;
  }

  ::v-deep .el-form--inline .el-form-item {
    margin-right: 6px;
  }

  .sku_item {
    gap: 6px;
  }

  .info-label {
    flex-basis: 52px;
  }
}

.strike {
  text-decoration: line-through;
  color: #999;
  margin-right: 4px;
}

.sku-name.link {
  color: #4569c8;
  /* 蓝色字体，让用户知道可点击 */
  cursor: pointer;
  /* 鼠标变成小手 👆 */
}

.sku-name.link:hover {
  text-decoration: underline;
  /* 鼠标移上去出现下划线 */
}
</style>